<template>
  <a-card>
    <div slot="title" class="title">
      <div class="vertical"></div>
      新增管道公里数
    </div>
    <div slot="extra" class="extra">
      <a-date-picker
        mode="year"
        placeholder="请选择年份"
        format="YYYY"
        valueFormat="YYYY"
        v-model="year"
        style="100%"
        :open="yearShowOne"
        @openChange="openChangeOne"
        @panelChange="panelChangeOne"
      />
    </div>
    <div class="main">
      <div class="box">
        <a-row class="pipeline" v-for="item in pipelineList" :key="item.id">
          <a-col class="pipelineName" :span="6">{{ item.pipeline }}</a-col>
          <a-col class="pipelineName" :span="8">{{ item.materialType }}</a-col>
          <a-col class="pipelineName" :span="10">公里数：{{ item.mileage }}KM</a-col>
        </a-row>
        <!-- <div class="pipeline" v-for="item in pipelineList" :key="item.id">
          <div class="pipelineName">{{ item.pipeline }}</div>
          <div class="pipelineName">{{ item.materialType }}</div>
          <div class="kilometre">公里数：{{ item.mileage }}KM</div>
        </div> -->
      </div>
    </div>
  </a-card>
</template>

<script>
export default {
  data() {
    return {
      pipelineList: [],
      year: '',
      yearShowOne: false,
      yeare: '',
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 弹出日历和关闭日历的回调
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true
      }
    },
    // 得到年份选择器的值
    panelChangeOne(value, dateString) {
      this.year = value
      this.yearShowOne = false
      this.yeare = value.format('yyy')
      this.getList()
    },
    //新增管道公里数
    getList() {
      this.$http
        .get('/pipe-network//engineering_project_checks/low-right', {
          params: {
            year: this.yeare,
          },
        })
        .then((res) => {
          console.log(res.data, '新增管道公里数')
          this.pipelineList = res.data
        })
    },
  },
}
</script>

<style lang='less' scoped>
/deep/.ant-card-body {
  padding: 0;
}
.a-card {
  width: 100%;
  height: 100%;
}
.title {
  display: flex;
  align-items: center;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}
.vertical {
  width: 4px;
  height: 18px;
  margin-right: 10px;
  background: #0265ff;
  border-radius: 3px;
}
.main {
  width: 100%;
  height: 269px;
  // overflow: auto;
}

.box {
  // width: 98%;
  height: 269px;
  overflow-y: scroll;
  // margin: 0 auto;
  // margin-top: -12px;
}
.box::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 0px;
}
.box::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  background: rgba(0, 0, 0, 0);
}
.box::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0);
}

.pipeline {
  width: 93%;
  height: 58px;
  padding: 0 24px;
  margin: 0 auto;
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f1f5fb;
  border-radius: 4px;
  overflow: auto;
}
.pipelineName {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #525254;
  font-weight: 400;
}
.kilometre {
  font-family: MicrosoftYaHeiSemibold;
  font-size: 20px;
  color: #363636;
  letter-spacing: 0.11px;
  text-align: right;
  font-weight: 600;
}
</style>